import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { EQimaSnackbarType, QimaSnackbarModule } from '@qima/ngx-qima';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-notification-container',
  standalone: true,
  imports: [CommonModule, QimaSnackbarModule],
  template: `
    <div class="notification-container">
      @for (notification of notifications(); track $index) {
        <qima-snackbar
          [qimaSnackbarMessage]="notification.message"
          [qimaSnackbarType]="notification.type"
          [qimaSnackbarButtonLabel]="notification.buttonLabel"
          (qimaSnackbarButtonClick)="onNotificationButtonClick($index)"
        />
      }
    </div>
  `,
  styles: [
    `
      @use 'qima-imports' as *;

      .notification-container {
        position: fixed;
        top: $qima-spacing-l;
        right: $qima-spacing-l;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        gap: $qima-spacing-s;
        max-width: 400px;
      }
    `,
  ],
})
export class NotificationContainerComponent {
  public readonly notifications = this.notificationService.notifications;
  public readonly EQimaSnackbarType = EQimaSnackbarType;

  constructor(private readonly notificationService: NotificationService) {}

  public onNotificationButtonClick(index: number): void {
    this.notificationService.removeNotification(index);
  }
}
